import moment from 'moment';

export const generateDateTime = (dateString: string): string => {
  // Get the current time in HH:mm:ss format
  const currentTime = moment().format('HH:mm:ss');

  // Combine provided date with current time
  const combinedDateTime = `${dateString} ${currentTime}`;

  // Parse the combined local datetime and convert to UTC
  const utcDateTime = moment(combinedDateTime, 'YYYY-MM-DD HH:mm:ss')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');

  return utcDateTime;
};
